
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.31006',
  depVersions: {
  "feedback-public-submission-ui": "static-1.31006",
  "emoji-mart": "static-3.7",
  "feedback-schema": "static-1.55589",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8505",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11956",
  "I18n": "static-7.1706",
  "quartz": "static-1.7645",
  "quartz-config": "static-1.1423",
  "quartz-core": "static-1.6864",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1091",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55576",
  "feedback-utils": "static-1.55580",
  "forms-embed-utils-lib": "static-1.4930",
  "forms-utils-lib": "static-1.13325",
  "foundations-assets": "static-1.5354",
  "foundations-components": "static-1.8737",
  "foundations-theming": "static-1.4956",
  "hub-http": "static-1.6676",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12263",
  "icons": "static-2.701",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4228",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17204",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5653",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.517",
  "tinymce-plugins": "static-1.58496",
  "transmute": "static-2.97",
  "ui-images": "static-2.1275",
  "UIComponents": "static-3.8902",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3922",
  "quartz-webpack": "static-1.3869",
  "foundations-theming-specialty": "static-1.2672",
  "property-description-translator": "static-1.4287",
  "HeadJS": "static-2.820",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3616",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4777",
  "jasmine-runner": "static-1.6920",
  "opentelemetry-fe-types": "static-1.258",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4972",
  "mobile-manifest-mixins": "static-1.603",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.633",
  "quartz-auth": "static-1.1320",
  "quartz-head": "static-1.1310",
  "quartz-i18n": "static-1.1320",
  "quartz-routing": "static-1.1075",
  "quartz-test": "static-1.1320",
  "quartz-tracking": "static-1.1024",
  "trellis-components": "static-1.3084",
  "ui-fonts": "static-1.1218",
  "usage-tracker-container": "static-1.7780",
  "usage-tracker-core": "static-1.7640",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.356",
  "conversations-skeleton-state": "static-1.7607",
  "reference-resolvers": "static-1.8649",
  "sanitize-text": "static-1.8627",
  "PatternValidationJS": "static-1.3354",
  "ReduxMessenger": "static-2.10838",
  "outpost": "static-1.4598",
  "rpc-client-utils": "static-1.5139",
  "sanitize": "static-1.4942",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.5006",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9891",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.101",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3065",
  "bend-plugin-foundations-theming": "static-1.3439",
  "foundations-theming-base": "static-1.3941",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.397",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.169",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.10004",
  "atom": "static-1.5543",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8411",
  "ContentUtils": "static-1.69455",
  "data-token-picker": "static-1.17121",
  "file-manager-components": "static-1.24821",
  "FileManagerCore": "static-1.40320",
  "FileManagerLib": "static-1.40461",
  "frontend-preferences-client": "static-1.8389",
  "hub-http-contrib": "static-1.3499",
  "interframe": "static-3.5209",
  "layout-dnd-components": "static-1.13213",
  "layout-dnd-utils": "static-1.12188",
  "property-translator": "static-1.5847",
  "react-codemirror": "static-1.11109",
  "react-colorpicker": "static-2.10677",
  "reference-resolvers-lite": "static-1.8575",
  "rich-text-lib": "static-1.20539",
  "tinymce-data": "static-1.41467",
  "tinymce-themes": "static-1.57352",
  "ui-addon-emoji-picker": "static-1.10333",
  "ui-addon-sales-email": "static-1.5671",
  "ui-brand-identity-lib": "static-1.16927",
  "bender-build-tools": "static-1.3556",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10887",
  "hubspotter-http-shared-msw-handlers": "static-1.10885",
  "usage-tracker-session-replay": "static-1.5476",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1465",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.549",
  "chirp-fetch": "static-1.2372",
  "stylex-utils": "static-1.173",
  "chatspot-core": "static-1.23821",
  "copilot-toolkit": "static-1.12130",
  "customer-data-objects-ui-components": "static-1.13501",
  "data-fetching-client": "static-1.10107",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5226",
  "ui-addon-video-player": "static-1.9093",
  "ui-coaching-tips": "static-1.29576",
  "usage-tracker": "static-1.7790",
  "cms-field-types": "static-1.5278",
  "content-icons-ui": "static-1.2451",
  "integrations-lib": "static-1.17415",
  "customer-data-objects": "static-1.8168",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2132",
  "apollo-link-hub-http": "static-2.5055",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4610",
  "poll-commands": "static-1.3944",
  "ui-addon-iframeable": "static-1.9542",
  "video-components-external": "static-1.12416",
  "video-data-lib": "static-1.36074",
  "audio-components": "static-1.6558",
  "breeze-artifacts-sdk": "static-1.911",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30048",
  "FileManagerImages": "static-1.37972",
  "foundations-components-legacy": "static-1.1762",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.726",
  "ui-universal-auth": "static-1.9719",
  "urlinator": "static-1.4984",
  "video-components": "static-1.14418",
  "video-embed": "static-1.36908",
  "ts-schema": "static-1.4391",
  "ContentData": "static-1.69530",
  "layout-data-lib": "static-1.10513",
  "react-dnd-compat": "static-1.5079",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2014",
  "external-options-client-types": "static-1.4437",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6060",
  "hs-resources": "static-1.664",
  "inbound-db-properties-service-client": "static-1.4149",
  "NamespacedHubStyle": "static-2.9365",
  "growth-onboarding-confetti": "static-1.3529",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11614",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5904",
  "magpie-types": "static-1.5364",
  "simple-logging-lib": "static-1.3520",
  "avatar-components": "static-1.2954",
  "customer-data-ui-utilities": "static-1.10303",
  "growth-onboarding-feedback-components": "static-1.7051",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5348",
  "integrations-error-boundary-lib": "static-1.14830",
  "integrations-tracking-lib": "static-1.6085",
  "laboratory-lib": "static-3.7617",
  "native-integrations-shared-strings": "static-1.8231",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10745",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1110",
  "breeze-engine-core": "static-1.1410",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1113",
  "navigation-messaging": "static-1.8478",
  "content-media-composition-data-lib": "static-1.13578",
  "content-media-compositions": "static-2.17585",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19628",
  "nudge-client-utils": "static-1.3407",
  "custom-vendor-connection-lib": "static-1.283",
  "unified-auth-core-lib": "static-1.1515",
  "social-insights-client-types": "static-1.22914",
  "advanced-menus-core": "static-1.15805",
  "advanced-menus-lib": "static-1.12561",
  "ExportDialog": "static-6.10840",
  "ui-memberships-settings-lib": "static-1.35161",
  "conditional-properties-service-client": "static-1.4110",
  "crm-pipelines-api-client-types": "static-1.4440",
  "event-emitter": "static-1.1431",
  "fdsr-migration-layer": "static-1.480",
  "framework-builder-read-service-client": "static-1.4332",
  "inbound-db-meta-service-client": "static-1.3773",
  "multi-currency-client-types": "static-1.4005",
  "foundations-components-test-utils": "static-1.6220",
  "reactive-lib": "static-1.1191",
  "trellis-migration-context": "static-1.47",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.807",
  "universal-page-editor-lib": "static-1.3477",
  "bend-plugin-pulse": "static-1.616",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30788",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3164",
  "nudge-renderer-utils": "static-1.3483",
  "onboarding-tours": "static-1.17389",
  "whisper-core-api": "static-1.7621",
  "fsm": "static-1.4227",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15804",
  "simple-menus-lib": "static-1.17321",
  "settings-ui-lib": "static-1.12997",
  "persist-promise": "static-1.4171",
  "crm-record-cards-service-types": "static-1.3870",
  "framework-data-schema-resolvers": "static-1.7361",
  "location-customization-utils-lib": "static-1.10400",
  "getting-started-shared-tasks": "static-1.19547",
  "growth-data-modal": "static-1.6123",
  "growth-onboarding-next-action-utils": "static-1.2968",
  "navigation-components": "static-1.19151",
  "nest": "static-1.704",
  "onboarding-tours-client": "static-1.5604",
  "onboarding-tours-utils": "static-1.1456",
  "ui-shepherd-tracker": "static-1.8126",
  "user-context": "static-1.5521",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7266",
  "onboarding-data-sync-lib": "static-1.2830",
  "growth-onboarding-next-action-components": "static-1.2996",
  "user-context-client": "static-1.4979",
  "getting-started-shared-tasks-store": "static-1.18665",
  "InboxConnectUtils": "static-4.15829",
  "meetings-connect-utils-lib": "static-1.8086",
  "onboarding-scopes": "static-1.6921"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.31006",
  "emoji-mart": "/emoji-mart/static-3.7",
  "feedback-schema": "/feedback-schema/static-1.55589",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8505",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11956",
  "I18n": "/I18n/static-7.1706",
  "quartz": "/quartz/static-1.7645",
  "quartz-config": "/quartz-config/static-1.1423",
  "quartz-core": "/quartz-core/static-1.6864",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1091",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55576",
  "feedback-utils": "/feedback-utils/static-1.55580",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4930",
  "forms-utils-lib": "/forms-utils-lib/static-1.13325",
  "foundations-assets": "/foundations-assets/static-1.5354",
  "foundations-components": "/foundations-components/static-1.8737",
  "foundations-theming": "/foundations-theming/static-1.4956",
  "hub-http": "/hub-http/static-1.6676",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12263",
  "icons": "/icons/static-2.701",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4228",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17204",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5653",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.517",
  "tinymce-plugins": "/tinymce-plugins/static-1.58496",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1275",
  "UIComponents": "/UIComponents/static-3.8902",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3922",
  "quartz-webpack": "/quartz-webpack/static-1.3869",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2672",
  "property-description-translator": "/property-description-translator/static-1.4287",
  "HeadJS": "/HeadJS/static-2.820",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3616",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4777",
  "jasmine-runner": "/jasmine-runner/static-1.6920",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.258",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4972",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.603",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.633",
  "quartz-auth": "/quartz-auth/static-1.1320",
  "quartz-head": "/quartz-head/static-1.1310",
  "quartz-i18n": "/quartz-i18n/static-1.1320",
  "quartz-routing": "/quartz-routing/static-1.1075",
  "quartz-test": "/quartz-test/static-1.1320",
  "quartz-tracking": "/quartz-tracking/static-1.1024",
  "trellis-components": "/trellis-components/static-1.3084",
  "ui-fonts": "/ui-fonts/static-1.1218",
  "usage-tracker-container": "/usage-tracker-container/static-1.7780",
  "usage-tracker-core": "/usage-tracker-core/static-1.7640",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.356",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "reference-resolvers": "/reference-resolvers/static-1.8649",
  "sanitize-text": "/sanitize-text/static-1.8627",
  "PatternValidationJS": "/PatternValidationJS/static-1.3354",
  "ReduxMessenger": "/ReduxMessenger/static-2.10838",
  "outpost": "/outpost/static-1.4598",
  "rpc-client-utils": "/rpc-client-utils/static-1.5139",
  "sanitize": "/sanitize/static-1.4942",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5006",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9891",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3065",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3439",
  "foundations-theming-base": "/foundations-theming-base/static-1.3941",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.397",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.169",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10004",
  "atom": "/atom/static-1.5543",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8411",
  "ContentUtils": "/ContentUtils/static-1.69455",
  "data-token-picker": "/data-token-picker/static-1.17121",
  "file-manager-components": "/file-manager-components/static-1.24821",
  "FileManagerCore": "/FileManagerCore/static-1.40320",
  "FileManagerLib": "/FileManagerLib/static-1.40461",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8389",
  "hub-http-contrib": "/hub-http-contrib/static-1.3499",
  "interframe": "/interframe/static-3.5209",
  "layout-dnd-components": "/layout-dnd-components/static-1.13213",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12188",
  "property-translator": "/property-translator/static-1.5847",
  "react-codemirror": "/react-codemirror/static-1.11109",
  "react-colorpicker": "/react-colorpicker/static-2.10677",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8575",
  "rich-text-lib": "/rich-text-lib/static-1.20539",
  "tinymce-data": "/tinymce-data/static-1.41467",
  "tinymce-themes": "/tinymce-themes/static-1.57352",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10333",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5671",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16927",
  "bender-build-tools": "/bender-build-tools/static-1.3556",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10887",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10885",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5476",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1465",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.549",
  "chirp-fetch": "/chirp-fetch/static-1.2372",
  "stylex-utils": "/stylex-utils/static-1.173",
  "chatspot-core": "/chatspot-core/static-1.23821",
  "copilot-toolkit": "/copilot-toolkit/static-1.12130",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13501",
  "data-fetching-client": "/data-fetching-client/static-1.10107",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5226",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9093",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29576",
  "usage-tracker": "/usage-tracker/static-1.7790",
  "cms-field-types": "/cms-field-types/static-1.5278",
  "content-icons-ui": "/content-icons-ui/static-1.2451",
  "integrations-lib": "/integrations-lib/static-1.17415",
  "customer-data-objects": "/customer-data-objects/static-1.8168",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2132",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5055",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4610",
  "poll-commands": "/poll-commands/static-1.3944",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9542",
  "video-components-external": "/video-components-external/static-1.12416",
  "video-data-lib": "/video-data-lib/static-1.36074",
  "audio-components": "/audio-components/static-1.6558",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.911",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30048",
  "FileManagerImages": "/FileManagerImages/static-1.37972",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1762",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.726",
  "ui-universal-auth": "/ui-universal-auth/static-1.9719",
  "urlinator": "/urlinator/static-1.4984",
  "video-components": "/video-components/static-1.14418",
  "video-embed": "/video-embed/static-1.36908",
  "ts-schema": "/ts-schema/static-1.4391",
  "ContentData": "/ContentData/static-1.69530",
  "layout-data-lib": "/layout-data-lib/static-1.10513",
  "react-dnd-compat": "/react-dnd-compat/static-1.5079",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2014",
  "external-options-client-types": "/external-options-client-types/static-1.4437",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6060",
  "hs-resources": "/hs-resources/static-1.664",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4149",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11614",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5904",
  "magpie-types": "/magpie-types/static-1.5364",
  "simple-logging-lib": "/simple-logging-lib/static-1.3520",
  "avatar-components": "/avatar-components/static-1.2954",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10303",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7051",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5348",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14830",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6085",
  "laboratory-lib": "/laboratory-lib/static-3.7617",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8231",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10745",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1110",
  "breeze-engine-core": "/breeze-engine-core/static-1.1410",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1113",
  "navigation-messaging": "/navigation-messaging/static-1.8478",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13578",
  "content-media-compositions": "/content-media-compositions/static-2.17585",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19628",
  "nudge-client-utils": "/nudge-client-utils/static-1.3407",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.283",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1515",
  "social-insights-client-types": "/social-insights-client-types/static-1.22914",
  "advanced-menus-core": "/advanced-menus-core/static-1.15805",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12561",
  "ExportDialog": "/ExportDialog/static-6.10840",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35161",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4110",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4440",
  "event-emitter": "/event-emitter/static-1.1431",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.480",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4332",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4005",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6220",
  "reactive-lib": "/reactive-lib/static-1.1191",
  "trellis-migration-context": "/trellis-migration-context/static-1.47",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.807",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3477",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.616",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30788",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3164",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3483",
  "onboarding-tours": "/onboarding-tours/static-1.17389",
  "whisper-core-api": "/whisper-core-api/static-1.7621",
  "fsm": "/fsm/static-1.4227",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15804",
  "simple-menus-lib": "/simple-menus-lib/static-1.17321",
  "settings-ui-lib": "/settings-ui-lib/static-1.12997",
  "persist-promise": "/persist-promise/static-1.4171",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3870",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7361",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10400",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19547",
  "growth-data-modal": "/growth-data-modal/static-1.6123",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2968",
  "navigation-components": "/navigation-components/static-1.19151",
  "nest": "/nest/static-1.704",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5604",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1456",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8126",
  "user-context": "/user-context/static-1.5521",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7266",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2830",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2996",
  "user-context-client": "/user-context-client/static-1.4979",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18665",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15829",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8086",
  "onboarding-scopes": "/onboarding-scopes/static-1.6921"
}
};
